export default "__VITE_ASSET__68843665__"